import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { GridColumnType } from "../../../../data/gridColumnType";

export const assignUserFormData = {
    name: "Add Edit Assign User Form",
    initialState: { userName: "" },
    section: [
      {
        sectionId: 'AssignUser',
        title: "Assign User Section",
        row: {},
        style: {
          sectionStyle: "row mb-3",
        },
        fields: [
          {
            id: "userId",
            label: "Users",
            Field_Name: "users",
            fieldType: FormFieldTypes.SELECT,
            dataField: "userId",
            fieldSetting: {
              placeholder: "Please Select Users",
              isEnableOnChange: true
            },
            validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss: "col-xxl-12 col-xl-12 col-md-12",
            },
          },
        ]
      }
    ],
    formSetting: {
      isViewOnly: false
    }
  };
  export const assignUserGridConfig = {
    columns: [
      {
        name: "User Name",
        fieldName: "userName",
        colStyle: {
          width: "80%",
        },
        allowShort: true,
      },
      {
        name: "Action",
        colStyle: {
          width: "20%",
        },
        colType: GridColumnType.ACTION,
        defaultAction: {
          allowEdit: false,
          allowDelete: true,
        },
      },
    ],
  }